module.exports = __webpack_public_path__ + "img/花容月貌铭牌.fcbbdbd1.png";